'use client';

import type { Theme, SxProps } from '@mui/material/styles';

import { useId } from 'react';
import { Icon } from '@iconify/react';

import Box from '@mui/material/Box';

import { GUIDE_EMOJI_ICONS } from '../constants/guide-emoji-icons';

import type { GuideEmojiIconId } from '../constants/guide-emoji-icons';

/**
 * 가이드의 색 아이콘(Fluent Emoji) 한 개 — 실린 몸통을 바로 그린다(밖에서 받아 오지 않아 첫 그림부터 선다).
 * 실리지 않은 열쇠면 아무것도 그리지 않는다.
 * ⚠️ 그림 속 그라데이션 id 를 `useId` 로 고정한다 — 비우면 서버와 브라우저가 다른 id 를 지어 hydration 이 어긋난다.
 * @param icon `fluent-emoji:<이름>`
 * @param width 한 변(px)
 */
export function GuideEmojiIcon({ icon, width = 24, sx }: { icon: string; width?: number; sx?: SxProps<Theme> }) {
  const id = useId();
  const data = GUIDE_EMOJI_ICONS[icon as GuideEmojiIconId];
  if (!data) return null;
  return (
    <Box component="span" aria-hidden sx={[{ display: 'inline-flex', flexShrink: 0, width, height: width }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Icon icon={data} id={id} ssr width={width} height={width} />
    </Box>
  );
}
